<template>
<div class="chapter">
<div class="inner_page">
<h2 class="author">9</h2>
<p class="vers"><span>Narr</span>, der du suchst,
dich auf eignen<br class="calibre1"/>
Schultern zu tragen; o Bettler, der du<br class="calibre1"/>
kommst, an eignen Türen zu betteln!</p>
<p class="vers">Leg deine Lasten in seine Hände, der<br class="calibre1"/>
alles trägt und schaue nicht zurück in<br class="calibre1"/>
Bedauern.</p>
<p class="vers">Deine Begierde löschet sogleich das<br class="calibre1"/>
Licht der Lampe, die sie mit ihrem Atem<br class="calibre1"/>
berührt. Unheilig ist sie – nimm nicht<br class="calibre1"/>
deine Gaben aus ihren unreinen Händen.<br class="calibre1"/>
Nimm nur, was heilige Liebe dir bietet. <a id="page12" title="rudi49/wedi"></a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0010.vue?e8f38988